import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import auth from "../services/authService";
import config from "../config.json";
import Pagination from "../comman/pagination";
import { paginate, calculateIndex } from "../utlis/paginate";
import PartnerPerformerTable from "./PartnerPerformerTable";
import PageSizeOptions from "./PageSizeOptions";
import ActiveDeactiveHistory from "./SystemAdministration/ManagePartner/ActiveDeactiveHistory";
import { getLoggedUser, getLoggedUserDetails, getCurrentUser } from "../app/store/auth";
import {
  getSubcontractorPerformers, loadSubcontractorPerformers,
  AddSubcontractorPerformer, getAddedSubPerformerStatus,
  loadSubcontractorBprmForm,
  getSubcontractorBprmForm,
  loadSubcontractorsByFilter,
  getFilterAllSubcontractors
} from "../app/store/subcontractor";
import {
  getRecruiterPerformers, loadRecruiterPerformers,
  AddRecruiterPerformer, getAddedRecPerfromerStatus,
  loadRecruiterBprmForm,
  getRecruiterBprmForm,
  getReminderStatus,
  loadRecruiters,
  getFilterAllRecruiters,
  reminderSent
} from "../app/store/recruiter";
import { setCurrentPageTitle, setCurrentRoute } from "../app/store/layoutUI";
import { getFormatedNumber } from "../services/appService";
import Moment from "react-moment";
import { SendReminder } from "../app/store/recruiter";
import { Tab, Tabs } from "react-bootstrap";
import WorkflowElement from "../app/components/WorkflowElement";
import { getAlert } from "../services/appAlerts";
import AddPartnerPerformer from "./AddPartnerPerformer";

export default function ManagePartnerPerformer(props) {

  const routeArray = [
    { name: "System Administration", url: "" },
    { name: "Manage Entities", url: "" },
  ];
  //const [route,setRoute]=useState(routeArray)
  const [partnerType, setPartnerType] = useState("Recruiter")
  const [performers, setPerformers] = useState([]);
  const [filterData, setFilterData] = useState([]);

  const [rowsCount, setRowsCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(5);

  const [showHide, setShowHide] = useState(false);
  const [logShowHide, setLogShowHide] = useState(false);
  const [remainderMsgShowHide, setRemainderMsgShowHide] = useState(false);

  const [selectedObj, setSelectedObj] = useState(null);
  const [currentUser, setCurrentUser] = useState("");
  const [loggedUser, setLoggedUser] = useState("");

  const [performerId, setPerformerId] = useState("");
  const [performerName, setPerformerName] = useState("");
  const [mobile, setMobile] = useState("");

  const [actionType, setActionType] = useState("action");
  const [selectedUserId, setSelectedUserId] = useState(0);
  const [selectedKey, setSelectedKey] = useState("home");
  const [updatedStateData, setUpdatedStateData] = useState(null);
  const [viewFormType, setViewFormType] = useState("");
  const [wfTask, setWfTask] = useState(null);
  const [wfForm, setWfForm] = useState(null);
  const [performerdata, setPerformerdata] = useState({});
  const [dataType, setDataType] = useState("");
  const [isFiltering, setIsFiltering] = useState(false);

  const subcontractorPerformers = useSelector(getSubcontractorPerformers);
  const recruiterPerformers = useSelector(getRecruiterPerformers);

  const subPerformerAdded = useSelector(getAddedSubPerformerStatus);
  const recPerformerAdded = useSelector(getAddedRecPerfromerStatus);

  const subcontractorBprmFormSelector = useSelector(getSubcontractorBprmForm);
  const recruiterBprmFormSelector = useSelector(getRecruiterBprmForm)
  const filterAllRecruiters = useSelector(getFilterAllRecruiters);
  const filterAllSubcontractors = useSelector(getFilterAllSubcontractors);

  const userDetails = useSelector(getLoggedUserDetails);
  const remiderStatus = useSelector(getReminderStatus);

  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (subcontractorBprmFormSelector) setWfForm(subcontractorBprmFormSelector);
  }, [subcontractorBprmFormSelector])

  useEffect(() => {
    if (recruiterBprmFormSelector) setWfForm(recruiterBprmFormSelector);
  }, [recruiterBprmFormSelector])

  useEffect(() => {
    const state = location?.state;
    if (state?.partner && state?.url) {
      routeArray.push({ name: state.partner, url: state.url });
    }
    dispatch(setCurrentRoute(routeArray));
    dispatch(setCurrentPageTitle("Manage Users"))
  }, [])


  useEffect(() => {
    const state = location?.state;
    var frmBody = new FormData();
    frmBody.append("name", "");
    frmBody.append("email", "");
    if (state?.obj) {
      const currentObj = state.obj;
      setCurrentUser(currentObj);
      if (currentObj?.partnerType === "Sub-Contractors") {
        setPartnerType("Subcontractor");
        if (currentObj?.fuid) {
          dispatch(loadSubcontractorPerformers(currentObj.fuid));
        }
        frmBody.append("id", currentObj?.fuid || "");
        frmBody.append("type", "Sub-Contractors");
        dispatch(loadSubcontractorsByFilter(frmBody));
      }
      else {
        if (currentObj?.fuid) {
          dispatch(loadRecruiterPerformers(currentObj.fuid));
        }
        frmBody.append("id", currentObj?.fuid || "");
        frmBody.append("type", "Recruiter");
        dispatch(loadSubcontractorsByFilter(frmBody));
      }
    }
  }, []);

  useEffect(() => {
    setPerformerdata(filterAllRecruiters[0])
  }, [filterAllRecruiters])

  useEffect(() => {
    setPerformerdata(filterAllSubcontractors[0])
  }, [filterAllSubcontractors])

  useEffect(() => {
    getPagedData(subcontractorPerformers, currentPage, pageSize);
  }, [subcontractorPerformers]);

  useEffect(() => {
    getPagedData(recruiterPerformers, currentPage, pageSize);
  }, [recruiterPerformers]);

  useEffect(() => {
    const user = getCurrentUser();
    if (user?.type === "admin" && userDetails !== null) {
      const usrDetails = { ...userDetails, roleType: "admin" };
      setLoggedUser(usrDetails);
    }
  }, [userDetails]);

  useEffect(() => {
    if (subPerformerAdded && currentUser?.fuid) {
      dispatch(loadSubcontractorPerformers(currentUser.fuid));
    }
  }, [subPerformerAdded])

  useEffect(() => {
    if (recPerformerAdded && currentUser?.fuid) {
      dispatch(loadRecruiterPerformers(currentUser.fuid));
    }
  }, [recPerformerAdded])


  const handleSelection = (item) => {
    if (selectedUserId === item.id) {
      handleResetSelection();
      return;
    }
    const obj = performers.filter(x => x.id === item.id);
    if (obj.length > 0) {
      setSelectedObj(obj[0]);
      setSelectedUserId(item.id);
    }
  };


  const handleFormSubmit = (performer) => {
    if (currentUser?.fuid > 0) {
      performer["partnerId"] = currentUser.fuid;
      if (partnerType === "Subcontractor")
        dispatch(AddSubcontractorPerformer(performer));
      else
        dispatch(AddRecruiterPerformer(performer));
      setShowHide(!showHide);
    }
  };

  const getPagedData = (list, currentPage, pageSize) => {
    const items = paginate(list, currentPage, pageSize);
    setRowsCount(list.length);
    setPerformers(items);
  };

  const handleLogShowHide = (item, actionType) => {
    if (item === "save") {
      setLogShowHide(false);
      setSelectedObj("");
      setActionType(actionType);
      if (partnerType === "Subcontractor") {
        if (currentUser?.fuid) {
          dispatch(loadSubcontractorPerformers(currentUser.fuid));
        }
      } else {
        if (currentUser?.fuid) {
          dispatch(loadRecruiterPerformers(currentUser.fuid));
        }
      }
    } else {
      setLogShowHide(!logShowHide);
      setSelectedObj(item);
      setActionType(actionType);
    }
  };

  const handleTabSelect = (tab) => {
    setSelectedKey(tab);
  }

  const getSourcePerformers = () =>
    partnerType === "Subcontractor" ? subcontractorPerformers : recruiterPerformers;

  const handleFilter = async () => {
    setIsFiltering(true);
    let filtered =
      performerId !== ""
        ? getSourcePerformers().filter((p) => p.id === parseInt(performerId))
        : getSourcePerformers();

    filtered =
      performerName !== ""
        ? filtered.filter((x) =>
          x.name?.toLowerCase().includes(performerName.toLowerCase())
        )
        : filtered;

    filtered =
      mobile !== ""
        ? filtered.filter((x) => x.contact && x.contact.includes(mobile))
        : filtered;

    getPagedData(filtered, 1, pageSize)
    setDataType("filter");
    setTimeout(() => {
      setIsFiltering(false);
    }, 600);
  };

  const handleFilterCancel = () => {
    getPagedData(getSourcePerformers(), 1, pageSize);

    setPerformerId("");
    setPerformerName("");
    setMobile("");
    setDataType("");
    setIsFiltering(false);
  };

  const formatPhoneNumber = (value) => {
    if (!value) return value;
    const n = value.replace(/[^\d]/g, "");
    if (n.length < 4) return n;
    if (n.length < 7) return n.slice(0, 3) + "-" + n.slice(3);
    return n.slice(0, 3) + "-" + n.slice(3, 6) + "-" + n.slice(6, 10);
  };

  const getDisplayName = (performer) =>
    [performer?.name, performer?.lastName].filter(Boolean).join(" ").trim() || "Unnamed User";

  const getInitials = (performer) => {
    const nameParts = getDisplayName(performer).split(" ").filter(Boolean);
    return nameParts.slice(0, 2).map((part) => part.charAt(0).toUpperCase()).join("");
  };


  const handlePageChange = (page) => {
    const { startIndex: start, endIndex: end } = calculateIndex(page, startIndex, endIndex);
    setCurrentPage(page);
    setStartIndex(start);
    setEndIndex(end);
    if (partnerType === "Subcontractor")
      getPagedData(subcontractorPerformers, page, pageSize);
    else
      getPagedData(recruiterPerformers, page, pageSize);
  };

  const handlePageSizeChanged = ({ currentTarget }) => {
    const newSize = Number(currentTarget.value);
    setPageSize(newSize);
    setCurrentPage(1);
    setStartIndex(0);
    setEndIndex(5);
    if (partnerType === "Subcontractor")
      getPagedData(subcontractorPerformers, 1, newSize);
    else
      getPagedData(recruiterPerformers, 1, newSize);
  };

  const handleNextTask = () => {
    console.log("")
  }

  const handleViewSubcontractorForm = (type, item) => {
    if (viewFormType === type) {
      setViewFormType("");
      setUpdatedStateData(null)
    } else {
      if (item.partnerType === "Sub-Contractors") {
        setWfTask({ formId: config.formIds.subcontractor, ciid: 0 });
        dispatch(loadSubcontractorBprmForm(config.formIds.subcontractor))
      } else {
        setWfTask({ formId: config.formIds.recruiter, ciid: 0 });
        dispatch(loadRecruiterBprmForm(config.formIds.recruiter))
      }
      setViewFormType(type);
      setUpdatedStateData(item.contact1.performerData);
    }
  }

  const handleRemainder = async (id) => {
    dispatch(SendReminder(id));
  };

  useEffect(() => {
    const state = location?.state;
    var frmBody = new FormData();
    frmBody.append("name", "");
    frmBody.append("email", "");
    if (remiderStatus === "success") {
      getAlert("", "Reminder Sent Successfully", "success");
      if (state?.obj) {
        const currentObj = state.obj;
        if (currentObj?.partnerType === "Sub-Contractors") {
          frmBody.append("id", currentObj?.fuid);
          frmBody.append("type", "Sub-Contractors");
          dispatch(loadSubcontractorsByFilter(frmBody));
        }
        else {
          frmBody.append("id", currentObj?.fuid);
          frmBody.append("type", "Recruiter");
          dispatch(loadSubcontractorsByFilter(frmBody));
        }
      }
    }
    dispatch(reminderSent())
  }, [remiderStatus])

  const handleRemainderMessage = () => {
    setRemainderMsgShowHide(!remainderMsgShowHide);
  };

  const handleResetSelection = () => {
    setSelectedUserId(0);
    setSelectedObj(null);
  }

  const handlePermissionShowHide = () => {
    handleResetSelection()
    setSelectedKey("home");
  };

  const handlePermissionShowHide2 = () => {
    if (currentUser?.fuid) {
      if (partnerType === "Subcontractor") {
        dispatch(loadSubcontractorPerformers(currentUser.fuid, true));
      } else {
        dispatch(loadRecruiterPerformers(currentUser.fuid, true));
      }
    }
    setSelectedKey("home");
  };

  const handleAddUser = () => {
    handleResetSelection();
    setSelectedKey("addedituser");
  };

  const handleRefresh = () => {
    if (currentUser?.fuid) {
      if (partnerType === "Subcontractor") {
        dispatch(loadSubcontractorPerformers(currentUser.fuid, true));
      } else {
        dispatch(loadRecruiterPerformers(currentUser.fuid, true));
      }
    }
  };

  let item = "";
  if (currentUser) item = currentUser;
  const activeCount = getSourcePerformers().filter(p => p.status).length;

  return (
    <React.Fragment>
      <style>{`
        /* ── Animations ── */
        @keyframes searchSlideDown {
          from { opacity: 0; transform: translateY(-8px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes shimmer {
          0%   { background-position: -600px 0; }
          100% { background-position:  600px 0; }
        }
        @keyframes loadingBar {
          0%   { width: 0%;   opacity: 1; }
          70%  { width: 85%;  opacity: 1; }
          100% { width: 100%; opacity: 0; }
        }
        @keyframes rowFadeIn {
          from { opacity: 0; transform: translateY(4px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes tabFadeIn {
          from { opacity: 0; transform: translateY(6px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        /* ── Badges ── */
        .badge-capsule {
          display: inline-flex !important; align-items: center !important; justify-content: center !important;
          padding: 4px 10px !important; border-radius: 0 !important;
          font-size: 12px !important; font-weight: 500 !important; line-height: 1 !important;
        }
        .badge-system { background: #f1f5f9 !important; color: #475569 !important; border: 1px solid #cbd5e1 !important; }
        .badge-azure { background: rgba(37,99,235,0.08) !important; color: #1d4ed8 !important; border: 1px solid rgba(37,99,235,0.15) !important; }
        .badge-active { background: rgba(16,185,129,0.08) !important; color: #047857 !important; border: 1px solid rgba(16,185,129,0.15) !important; }
        .badge-inactive { background: rgba(239,68,68,0.08) !important; color: #b91c1c !important; border: 1px solid rgba(239,68,68,0.15) !important; }
        .badge-success-modern { background: rgba(16,185,129,0.08) !important; color: #047857 !important; border: 1px solid rgba(16,185,129,0.15) !important; }
        .badge-warning-modern { background: rgba(245,158,11,0.08) !important; color: #b45309 !important; border: 1px solid rgba(245,158,11,0.15) !important; }


        /* ── Animations ── */
        @keyframes searchSlideDown {
          from { opacity: 0; transform: translateY(-8px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes shimmer {
          0%   { background-position: -600px 0; }
          100% { background-position:  600px 0; }
        }
        @keyframes rowFadeIn {
          from { opacity: 0; transform: translateY(4px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes tabFadeIn {
          from { opacity: 0; transform: translateY(6px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes emptyFadeUp {
          from { opacity: 0; transform: translateY(18px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        /* ── Main Card ── */
        .wf-main-card {
          background: rgba(255, 255, 255, 0.97) !important;
          border: 1px solid #cbd5e1 !important;
          box-shadow: 0 4px 24px -4px rgba(15, 23, 42, 0.06), 0 1px 4px -1px rgba(15, 23, 42, 0.04) !important;
          border-radius: 0 !important;
          transition: all 0.3s ease !important;
          overflow: hidden !important;
          position: relative !important;
          height: auto !important;
          min-height: 420px !important;
          display: flex !important;
          flex-direction: column !important;
          margin-bottom: 0 !important;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
        }

        /* ── Card Header Section ── */
        .wf-header-section {
          display: flex; align-items: flex-start; justify-content: space-between;
          flex-wrap: wrap; gap: 18px; padding: 22px 24px 18px;
          background: #ffffff;
          border-bottom: 1px solid #f1f5f9;
          position: relative;
          overflow: hidden;
        }
        .wf-header-left { display: flex; align-items: flex-start; gap: 14px; flex: 1; min-width: 260px; }
        .wf-header-right {
          display: flex;
          align-items: flex-start;
          gap: 8px;
          flex-wrap: wrap;
        }
        .wf-icon-box {
          width: 44px; height: 44px; border-radius: 0 !important;
          background: #f5f5f5; border: 1px solid #d4d4d4;
          display: flex; align-items: center; justify-content: center;
          color: #64748b; font-size: 18px; flex-shrink: 0;
          box-shadow: none;
        }
        .wf-title-block { min-width: 0; }
        .wf-title { font-size: 18px; font-weight: 600; color: #0f172a; margin: 0; line-height: 1.2; }
        .wf-subtitle { font-size: 14px; font-weight: 400; color: #64748b; margin: 6px 0 0; }
        .wf-header-meta { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; margin-top: 12px; }
        .wf-meta-pill {
          display: inline-flex; align-items: center; gap: 6px;
          padding: 4px 10px; border-radius: 0 !important; background: transparent !important;
          border: 1px solid #d4d4d4; color: #64748b; font-size: 12px; font-weight: 500;
        }
        .wf-meta-pill i { color: #64748b; font-size: 12px; }
        .wf-meta-pill.is-active i { color: #047857; }
        .wf-meta-pill.is-inactive i { color: #b91c1c; }

        /* ── Table Toolbar ── */
        .wf-toolbar {
          display: flex; align-items: center; justify-content: space-between;
          padding: 12px 20px; background: #ffffff; border-bottom: 1px solid #f1f5f9;
        }

        /* ── Search Panel ── */
        .search-panel-collapse {
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 0 !important;
          padding: 0 !important;
          box-shadow: none !important;
          animation: searchSlideDown 0.3s cubic-bezier(0.16,1,0.3,1) both;
          margin-top: 12px !important;
          margin-bottom: 8px !important;
          overflow: hidden !important;
        }
        .sp-header {
          display: flex; align-items: center; justify-content: space-between;
          padding: 14px 20px 12px;
          border-bottom: 1px solid rgba(226,232,240,0.8);
          background: #f8fafc;
        }
        .sp-header-title {
          display: flex; align-items: center; gap: 8px;
          font-size: 14px; font-weight: 500; color: #1e293b; letter-spacing: 0.1px;
        }
        .sp-header-title i { color: #64748b; font-size: 14px; }
        .sp-body { padding: 18px 20px 14px; }
        .sp-footer {
          display: flex; align-items: center; justify-content: center; gap: 8px;
          padding: 12px 20px;
          border-top: 1px solid rgba(226,232,240,0.7);
          background: #ffffff;
        }
        .wf-control-label {
          font-size: 12px !important; font-weight: 600 !important; color: #64748b !important;
          text-transform: uppercase !important; letter-spacing: 0.7px !important;
          margin-bottom: 7px !important; display: flex !important; align-items: center !important; gap: 5px !important;
        }
        .wf-control-label i { color: #94a3b8; font-size: 12px; }
        .wf-input-wrap { position: relative; }
        .wf-input-icon {
          position: absolute; left: 12px; top: 50%; transform: translateY(-50%);
          color: #94a3b8; font-size: 14px; pointer-events: none; transition: color 0.2s ease; z-index: 1;
        }
        .wf-input-wrap:focus-within .wf-input-icon { color: #2563eb; }
        .wf-input {
          border-radius: 0 !important; border: 1.5px solid #e2e8f0 !important;
          padding: 9px 14px 9px 36px !important; font-size: 14px !important; font-weight: 400 !important;
          color: #1e293b !important; background: #ffffff !important;
          transition: all 0.2s cubic-bezier(0.4,0,0.2,1) !important;
          height: auto !important; width: 100% !important;
          box-shadow: 0 1px 3px 0 rgba(0,0,0,0.03) !important;
        }
        .wf-filter-input-no-icon .wf-input { padding-left: 14px !important; }
        .wf-input::placeholder { color: #94a3b8 !important; font-weight: 400 !important; }
        .wf-input:hover { border-color: #94a3b8 !important; box-shadow: 0 2px 6px -1px rgba(0,0,0,0.06) !important; }
        .wf-input:focus {
          border-color: #2563eb !important;
          box-shadow: 0 0 0 4px rgba(37,99,235,0.1), 0 2px 6px -1px rgba(37,99,235,0.08) !important;
          outline: none !important; background: #fafbff !important;
        }

        /* ── Buttons ── */
        .btn-search-trigger {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 8px !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          padding: 7px 14px !important;
          border-radius: 0 !important;
          font-size: 14px !important;
          font-weight: 500 !important;
          letter-spacing: 0.01em !important;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
          color: #1e293b !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
          min-height: unset !important;
          height: auto !important;
          line-height: 1.25 !important;
        }
        .btn-search-trigger:hover {
          background: #f8fafc !important;
          color: #0f172a !important;
          border-color: #94a3b8 !important;
          box-shadow: 0 3px 8px rgba(15, 23, 42, 0.12) !important;
        }
        .btn-action-search {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 8px !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          padding: 7px 14px !important;
          border-radius: 0 !important;
          font-size: 14px !important;
          font-weight: 500 !important;
          letter-spacing: 0.01em !important;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
          color: #1e293b !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          outline: none !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
          min-height: unset !important;
          line-height: 1.25 !important;
        }
        .btn-action-search:hover {
          background: #f8fafc !important;
          color: #0f172a !important;
          border-color: #94a3b8 !important;
          transform: none !important;
          box-shadow: 0 3px 8px rgba(15, 23, 42, 0.12) !important;
        }
        .btn-action-search.btn-primary-search {
          background: #2563eb !important;
          color: #ffffff !important;
          border-color: #2563eb !important;
          box-shadow: 0 2px 5px rgba(37, 99, 235, 0.2) !important;
        }
        .btn-action-search.btn-primary-search:hover {
          background: #1d4ed8 !important;
          color: #ffffff !important;
          transform: none !important;
          box-shadow: 0 3px 8px rgba(37, 99, 235, 0.28) !important;
        }
        .btn-action-search.btn-danger-search {
          background: #ffffff !important;
          color: #991b1b !important;
          border: 1px solid #fca5a5 !important;
          box-shadow: 0 2px 5px rgba(220, 38, 38, 0.12) !important;
        }
        .btn-action-search.btn-danger-search:hover {
          background: #fff5f5 !important;
          color: #7f1d1d !important;
          border-color: #f87171 !important;
          transform: none !important;
          box-shadow: 0 3px 8px rgba(220, 38, 38, 0.16) !important;
        }

        /* ── Tabs ── */
        .wf-tab-bar {
          display: flex; align-items: stretch; gap: 4px;
          border-bottom: 2px solid #e5e5e5; margin-bottom: 0;
          padding: 8px 0 0; position: relative;
        }
        .wf-tab-bar,
        .wf-tab-bar *,
        .wf-tab-btn,
        .wf-tab-btn *,
        .wf-tab-btn:hover,
        .wf-tab-btn:focus,
        .wf-tab-btn:focus-visible,
        .wf-tab-btn:active,
        .wf-tab-btn.active,
        .wf-tab-btn.active:hover,
        .wf-tab-btn.active:focus,
        .wf-tab-btn.active:focus-visible,
        .wf-tab-btn.active:active,
        .wf-tab-btn.active *,
        .wf-tab-badge,
        .wf-tab-badge * {
          border-radius: 0 !important;
          -webkit-border-radius: 0 !important;
          -moz-border-radius: 0 !important;
        }
        .wf-tab-btn {
          position: relative; display: inline-flex; align-items: center; gap: 7px;
          border: none; background: transparent; padding: 9px 16px 11px;
          font-size: 14px; font-weight: 500; color: #1e293b;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
          cursor: pointer; border-radius: 0 !important;
          transition: color 0.2s ease, background 0.2s ease; outline: none; white-space: nowrap;
        }
        .wf-tab-btn i { font-size: 14px; color: currentColor; transition: color 0.2s ease; }
        .wf-tab-btn:hover { color: #0f172a; background: #f5f5f5; border-radius: 0 !important; }
        .wf-tab-btn:focus, .wf-tab-btn:focus-visible, .wf-tab-btn:active {
          outline: none !important; box-shadow: none !important; border-color: transparent !important; border-radius: 0 !important;
        }
        .wf-tab-btn.active,
        .wf-tab-btn.active:hover,
        .wf-tab-btn.active:focus,
        .wf-tab-btn.active:focus-visible,
        .wf-tab-btn.active:active { color: #ffffff !important; font-weight: 500 !important; background: #171717 !important; border-radius: 0 !important; }
        .wf-tab-btn.active i { color: #ffffff !important; }
        .wf-tab-badge {
          display: inline-flex; align-items: center; justify-content: center;
          min-width: 20px; height: 20px; padding: 0 6px; border-radius: 0 !important;
          font-size: 12px; font-weight: 600; background: #f1f5f9; color: #1e293b;
          border: 1px solid #e2e8f0; transition: all 0.2s ease; line-height: 1;
        }
        .wf-tab-btn.active .wf-tab-badge {
          background: #ffffff !important; color: #171717 !important; border-color: #ffffff !important; border-radius: 0 !important;
        }

        .wf-tab-panel {
          animation: tabFadeIn 0.28s cubic-bezier(0.16, 1, 0.3, 1) both;
          flex: 1 1 auto;
          min-height: auto;
          overflow-y: visible;
          overflow-x: hidden;
          padding-right: 4px;
          scrollbar-width: thin;
          scrollbar-color: #94a3b8 #f1f5f9;
        }

        /* ── Selected User Context Card ── */
        .wf-assign-card {
          display: flex; align-items: center; justify-content: space-between;
          gap: 20px; padding: 18px 22px;
          background: #ffffff;
          border: 1px solid #d4d4d4; border-radius: 0 !important;
          margin: 12px 0; flex-wrap: wrap;
          animation: tabFadeIn 0.3s ease both;
        }
        .wf-assign-info { display: flex; align-items: center; gap: 14px; }
        .wf-assign-avatar {
          width: 44px; height: 44px; border-radius: 0 !important;
          background: #171717;
          display: flex; align-items: center; justify-content: center;
          color: white; font-size: 16px; font-weight: 600; flex-shrink: 0;
        }
        .wf-assign-meta strong {
          display: block; font-size: 14px; font-weight: 600; color: #1e293b; margin-bottom: 3px;
        }
        .wf-assign-meta span { font-size: 12px; color: #64748b; font-weight: 400; }
        .wf-assign-actions { display: flex; gap: 8px; align-items: center; flex-wrap: wrap; }
        .wf-assign-actions .btn-action-search {
          height: auto !important;
          min-height: 32px !important;
          box-sizing: border-box !important;
          justify-content: center !important;
        }
        .wf-assign-actions .btn-danger-search {
          padding: 7px 12px !important;
          min-width: 32px !important;
        }

        /* ── Table ── */
        .wf-table-scroll table,
        .wf-table-scroll .wf-table {
          width: 100% !important;
          border-collapse: collapse !important;
          border: 1px solid #cbd5e1 !important;
        }
        .wf-table-scroll {
          overflow: auto !important; scrollbar-width: thin; scrollbar-color: #94a3b8 #f1f5f9;
          border-radius: 0 !important;
          border: none !important;
        }
        .wf-thead {
          background: #f8fafc !important;
          position: sticky !important; top: 0 !important; z-index: 2 !important;
        }
        .wf-thead th {
          font-size: 12px !important; font-weight: 600 !important; color: #64748b !important;
          text-transform: uppercase !important; letter-spacing: 0.6px !important;
          padding: 13px 16px !important; border-bottom: 2px solid #e2e8f0 !important;
          border-top: none !important; border-left: none !important; border-right: none !important; white-space: nowrap !important;
        }
        .wf-table-row {
          cursor: pointer !important;
          transition: background 0.15s ease, box-shadow 0.15s ease !important;
        }
        .wf-table-row:hover {
          background: #f5f5f5 !important;
          box-shadow: inset 3px 0 0 0 #171717 !important;
        }
        .wf-table-row:hover td { color: #1e293b !important; }
        .wf-table-row.selected-row {
          background: #f5f5f5 !important;
          box-shadow: inset 4px 0 0 0 #171717 !important;
        }
        .wf-table-row.selected-row:hover {
          background: #eeeeee !important;
        }
        .wf-table td {
          padding: 13px 16px !important; font-size: 14px !important; font-weight: 400 !important;
          color: #1e293b !important;
          border-bottom: 1px solid #f1f5f9 !important; border-top: none !important;
          border-left: none !important; border-right: none !important; vertical-align: middle !important;
        }
        .wf-id-cell {
          display: inline-flex; align-items: center; justify-content: center; gap: 6px;
          min-width: 64px; width: auto; padding: 4px 8px; border-radius: 0 !important;
          background: transparent !important; border: 1px solid #e2e8f0;
          font-size: 12px; font-weight: 500; color: #64748b;
        }
        .wf-id-cell.is-selected {
          background: #f5f5f5 !important; border-color: #d4d4d4 !important; color: #1e293b !important;
        }
        .wf-name-cell { display: flex; align-items: center; gap: 10px; min-width: 190px; }
        .wf-name-avatar {
          width: 34px; height: 34px; border-radius: 0 !important;
          display: inline-flex; align-items: center; justify-content: center;
          background: #f5f5f5;
          border: 1px solid #d4d4d4;
          color: #1e293b; font-size: 12px; font-weight: 500; flex-shrink: 0;
        }
        .wf-name-meta { display: flex; flex-direction: column; gap: 2px; min-width: 0; }
        .wf-name-main { font-size: 14px; font-weight: 500; color: #1e293b; text-transform: uppercase; }
        .wf-name-title,
        .wf-name-meta .wf-empty-value,
        .wf-empty-value {
          font-size: 12px !important;
          color: #94a3b8 !important;
          font-weight: 400 !important;
        }

        /* ── Login Type & Status Badges ── */
        .badge-capsule {
          display: inline-flex !important; align-items: center !important; justify-content: center !important;
          padding: 4px 8px !important; border-radius: 0 !important;
          width: 78px !important; min-width: 78px !important; text-align: center !important;
          font-size: 12px !important; font-weight: 500 !important; line-height: 1 !important;
          box-sizing: border-box !important;
        }
        .badge-system { background: #f1f5f9 !important; color: #475569 !important; border: 1px solid #cbd5e1 !important; }
        .badge-azure { background: rgba(37,99,235,0.08) !important; color: #1d4ed8 !important; border: 1px solid rgba(37,99,235,0.15) !important; }
        .badge-active { background: rgba(16,185,129,0.08) !important; color: #047857 !important; border: 1px solid rgba(16,185,129,0.15) !important; }
        .badge-inactive { background: rgba(239,68,68,0.08) !important; color: #b91c1c !important; border: 1px solid rgba(239,68,68,0.15) !important; }

        /* ── Simple Empty State ── */
        .wf-empty-state {
          display: flex; flex-direction: column; align-items: center; justify-content: center;
          padding: 40px 24px; text-align: center; gap: 12px;
          animation: tabFadeIn 0.3s ease both;
        }
        .wf-empty-icon {
          width: 52px; height: 52px; border-radius: 0 !important;
          display: flex; align-items: center; justify-content: center; font-size: 22px;
          background: #171717;
          border: 1px solid #171717; color: #ffffff; margin-bottom: 4px;
        }
        .wf-empty-title { font-size: 15px; font-weight: 600; color: #1e293b; margin: 0; }
        .wf-empty-desc { font-size: 14px; font-weight: 400; color: #64748b; margin: 0 auto; line-height: 1.6; }

      `}</style>

      <div className="col-md-12">
        <div className="card mb-4 shadow-none wf-main-card manage-partner-performer-page">
          {/* ── Premium Integrated Header ── */}
          <div className="wf-header-section">
            <div className="wf-header-left">
              <div className="wf-icon-box">
                <i className="fa fa-id-card-o" aria-hidden="true" />
              </div>
              <div className="wf-title-block">
                <h2
                  className="wf-title"
                  onClick={() => handleViewSubcontractorForm("Form", performerdata)}
                  style={{ cursor: "pointer" }}
                  title="Click to view partner details"
                >
                  {performerdata?.label || "Loading..."}
                  {performerdata?.fuid
                    ? ` (Partner ID: ${performerdata.fuid})`
                    : ""}
                </h2>

                <div className="wf-header-meta">
                  <span className="wf-meta-pill is-active">
                    <i className="fa fa-check-circle" aria-hidden="true" />
                    {activeCount} Active
                  </span>
                  <span className="wf-meta-pill is-inactive">
                    <i className="fa fa-times-circle" aria-hidden="true" />
                    {Math.max(rowsCount - activeCount, 0)} Inactive
                  </span>
                  <span className="wf-meta-pill">
                    <i className="fa fa-users" aria-hidden="true" />
                    {rowsCount} Users
                  </span>
                </div>
              </div>
            </div>

            <div className="wf-header-right" style={{ display: 'flex', gap: '8px', alignItems: 'flex-start' }}>
              <button
                className="btn-search-trigger"
                onClick={handleAddUser}
              >
                <i className="fa fa-user-plus" aria-hidden="true" /> Add User
              </button>
              <button
                className="btn-search-trigger"
                data-toggle="collapse"
                data-target="#partnerSearchPanel"
              >
                <i className="fa fa-filter" aria-hidden="true" /> Filters
              </button>
              <button
                className="btn-search-trigger"
                onClick={handleRefresh}
                title="Reload users"
              >
                <i className="fa fa-refresh" aria-hidden="true" /> Refresh
              </button>
              <button
                onClick={() => {
                  const returnTo = location.state?.returnTo;
                  const listState = location.state?.subcontractorListState;
                  if (returnTo && listState) {
                    navigate(returnTo, {
                      replace: true,
                      state: {
                        restoreSubcontractorList: true,
                        subcontractorListState: listState,
                      },
                    });
                    return;
                  }
                  navigate(-1);
                }}
                className="btn-search-trigger"
              >
                <i className="fa fa-arrow-left" aria-hidden="true" /> Back
              </button>
            </div>

          </div>

          {/* ── Toolbar ── */}
          <div className="wf-toolbar">
            <div className="d-flex align-items-center" style={{ gap: '14px' }}>
              <PageSizeOptions pageSize={pageSize} onChange={handlePageSizeChanged} />
            </div>
            <div className="d-flex align-items-center" style={{ gap: '8px' }}>
            </div>
          </div>

          {/* ── Search Panel ── */}
          <div className="px-3">
            <div className="collapse" id="partnerSearchPanel">
              <div className="search-panel-collapse">
                <div className="sp-header">
                  <span className="sp-header-title">
                    <i className="fa fa-sliders" />
                    Filter Users
                  </span>
                </div>
                <div className="sp-body">
                  <div className="row">
                    <div className="col-md-2 form-group mb-3">
                      <label htmlFor="performerId" className="wf-control-label">
                        ID
                      </label>
                      <div className="wf-input-wrap wf-filter-input-no-icon">
                        <input
                          type="text"
                          id="performerId"
                          className="form-control wf-input"
                          placeholder="e.g. 42"
                          value={performerId}
                          onChange={({ currentTarget }) => setPerformerId(currentTarget.value)}
                          onKeyDown={e => e.key === "Enter" && handleFilter()}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                    <div className="col-md-5 form-group mb-3">
                      <label htmlFor="performerName" className="wf-control-label">
                        Name
                      </label>
                      <div className="wf-input-wrap wf-filter-input-no-icon">
                        <input
                          type="text"
                          id="performerName"
                          className="form-control wf-input"
                          placeholder="Search user name…"
                          value={performerName}
                          onChange={({ currentTarget }) => setPerformerName(currentTarget.value)}
                          onKeyDown={e => e.key === "Enter" && handleFilter()}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                    <div className="col-md-5 form-group mb-3">
                      <label htmlFor="mobile" className="wf-control-label">
                        Mobile No.
                      </label>
                      <div className="wf-input-wrap wf-filter-input-no-icon">
                        <input
                          type="text"
                          id="mobile"
                          className="form-control wf-input"
                          placeholder="Mobile number…"
                          value={formatPhoneNumber(mobile)}
                          onChange={({ currentTarget }) => setMobile(currentTarget.value.replace(/[^\d]/g, ""))}
                          onKeyDown={e => e.key === "Enter" && handleFilter()}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="sp-footer">
                  <button
                    className="btn-action-search btn-danger-search"
                    data-toggle="collapse"
                    data-target="#partnerSearchPanel"
                    onClick={handleFilterCancel}
                  >
                    <i className="fa fa-times" aria-hidden="true" /> Clear &amp; Close
                  </button>
                  <button className="btn-action-search" onClick={handleFilterCancel}>
                    <i className="fa fa-refresh" aria-hidden="true" /> Reset
                  </button>
                  <button
                    className="btn-action-search btn-primary-search"
                    onClick={handleFilter}
                    disabled={isFiltering || (!performerId.trim() && !performerName.trim() && !mobile.trim())}
                  >
                    {isFiltering ? (
                      <>
                        <i className="fa fa-circle-o-notch fa-spin" aria-hidden="true" /> Applying...
                      </>
                    ) : (
                      <>
                        <i className="fa fa-search" aria-hidden="true" /> Apply Filters
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* ── Tabs & Content ── */}
          <div className="card-body px-3 pt-0 pb-3 wf-tabs-container">
            <div className="wf-tab-bar">
              <button
                className={`wf-tab-btn${selectedKey === "home" ? " active" : ""}`}
                onClick={() => setSelectedKey("home")}
              >
                <i className="fa fa-list-alt" />
                Users
                <span className="wf-tab-badge">{rowsCount > 0 ? rowsCount : "—"}</span>
              </button>
              <button
                className={`wf-tab-btn${selectedKey === "addedituser" ? " active" : ""}`}
                onClick={() => setSelectedKey("addedituser")}
              >
                <i className={`fa ${selectedUserId > 0 ? "fa-pencil-square-o" : "fa-user-plus"}`} />
                {selectedUserId > 0 ? "Edit" : "Add"} User
                {selectedUserId > 0 && (
                  <span className="wf-tab-badge">#{selectedUserId}</span>
                )}
              </button>
              <button
                className={`wf-tab-btn${selectedKey === "status" ? " active" : ""}${selectedUserId === 0 ? " tab-locked" : ""}`}
                onClick={() => setSelectedKey("status")}
                title="Activate or deactivate a user"
              >
                <i className="fa fa-toggle-on" />
                Activate / Deactivate
                {selectedUserId > 0 && (
                  <span className="wf-tab-badge">#{selectedUserId}</span>
                )}
              </button>
            </div>

            {selectedKey === "home" && (
              <div className="wf-tab-panel">
                {selectedUserId > 0 && selectedObj && (
                  <div className="wf-assign-card">
                    <div className="wf-assign-info">
                      <div className="wf-assign-avatar">
                        {(selectedObj.name || "?").charAt(0).toUpperCase()}
                      </div>
                      <div className="wf-assign-meta">
                        <strong>{selectedObj.name}</strong>
                        <span>
                          {selectedObj.email}
                          {selectedObj.title && <> &bull; {selectedObj.title}</>}
                          &nbsp;&bull;&nbsp;
                          <span className={`badge-capsule ${selectedObj.status ? "badge-active" : "badge-inactive"}`} style={{ padding: "2px 8px", fontSize: 12 }}>
                            {selectedObj.status ? "Active" : "Inactive"}
                          </span>
                        </span>
                      </div>
                    </div>
                    <div className="wf-assign-actions">
                      <button
                        className="btn-action-search"
                        onClick={() => handleTabSelect("addedituser")}
                      >
                        <i className="fa fa-pencil-square-o" /> Edit
                      </button>
                      <button
                        className="btn-action-search"
                        onClick={() => handleTabSelect("status")}
                      >
                        <i className="fa fa-toggle-on" /> Status
                      </button>
                      <button
                        className="btn-action-search btn-danger-search"
                        onClick={handleResetSelection}
                        title="Clear selection"
                        style={{ padding: "8px 12px" }}
                      >
                        <i className="fa fa-times" />
                      </button>
                    </div>
                  </div>
                )}

                <div className="table-responsive mt-2 wf-table-scroll">
                  <table className="table align-items-center table-flush wf-table">
                    <thead className="wf-thead">
                      <tr>
                        <th>ID</th>
                        <th>Date Added</th>
                        <th>Name &amp; Title</th>
                        <th>Email</th>
                        <th>Login Type</th>
                        <th>Azure Email</th>
                        <th>Contact No.</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {performers.length === 0 ? (
                        <tr>
                          <td colSpan={8} style={{ padding: 0 }}>
                            <div className="wf-empty-state">
                              <div className="wf-empty-icon">
                                <i className={dataType === "filter" ? "fa fa-search" : "fa fa-users"} aria-hidden="true" />
                              </div>
                              <p className="wf-empty-title">
                                {dataType === "filter" ? "No Matching Users" : "No Users Assigned"}
                              </p>
                              <p className="wf-empty-desc">
                                {dataType === "filter"
                                  ? "Try adjusting or resetting the filters to see users."
                                  : "There are no users assigned to this partner yet. Add a user to get started."}
                              </p>
                              {dataType === "filter" ? (
                                <button
                                  className="btn-action-search"
                                  onClick={handleFilterCancel}
                                  style={{ marginTop: 4 }}
                                >
                                  <i className="fa fa-refresh" aria-hidden="true" /> Reset Filters
                                </button>
                              ) : (
                                <button
                                  className="btn-action-search btn-primary-search"
                                  onClick={handleAddUser}
                                  style={{ marginTop: 4 }}
                                >
                                  <i className="fa fa-user-plus" /> Add First User
                                </button>
                              )}
                            </div>
                          </td>
                        </tr>
                      ) : (
                        performers.map((performer, idx) => (
                          <tr
                            key={performer.id}
                            className={`wf-table-row${selectedUserId === performer.id ? " selected-row" : ""}`}
                            onClick={() => handleSelection(performer)}
                            style={{ animationDelay: `${idx * 0.04}s` }}
                            title={selectedUserId === performer.id ? `Click to deselect: ${performer.name}` : `Click to select: ${performer.name}`}
                          >
                            <td>
                              <span>#{performer.id}</span>
                            </td>
                            <td>
                              <span className="wf-data-line">
                                {performer.addedDateTime ? (
                                  <Moment format="MMM Do YYYY">{performer.addedDateTime}</Moment>
                                ) : (
                                  <span className="wf-empty-value">Not available</span>
                                )}
                              </span>
                            </td>
                            <td>
                              <div className="wf-name-cell">
                                <span className="wf-name-avatar">{getInitials(performer)}</span>
                                <div className="wf-name-meta">
                                  <span className="wf-name-main">{getDisplayName(performer)}</span>
                                  {performer.title ? (
                                    <span className="wf-name-title">{performer.title}</span>
                                  ) : (
                                    <span className="wf-empty-value">No title</span>
                                  )}
                                </div>
                              </div>
                            </td>
                            <td>
                              <span className="wf-data-line wf-email-line">
                                {performer.email || <span className="wf-empty-value">No email</span>}
                              </span>
                            </td>
                            <td className="wf-login-type-cell">
                              {performer.loginType === 1 ? (
                                <span className="badge-capsule badge-azure">
                                  Azure AD
                                </span>
                              ) : (
                                <span className="badge-capsule badge-system">
                                  System
                                </span>
                              )}
                            </td>
                            <td className="wf-azure-email-cell">
                              {performer.azureEmailId ? (
                                <span className="wf-data-line wf-email-line">
                                  {performer.azureEmailId}
                                </span>
                              ) : (
                                <span className="wf-empty-value">Not linked</span>
                              )}
                            </td>
                            <td>
                              {performer.contact ? (
                                <span className="wf-data-line">
                                  {getFormatedNumber(performer.contact)}
                                </span>
                              ) : (
                                <span className="wf-empty-value">No contact</span>
                              )}
                            </td>
                            <td className="wf-status-cell">
                              {performer.status ? (
                                <span className="badge-capsule badge-active">
                                  Active
                                </span>
                              ) : (
                                <span className="badge-capsule badge-inactive">
                                  Inactive
                                </span>
                              )}
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
                <div className="mt-3">
                  <Pagination
                    currentPage={currentPage}
                    pageSize={pageSize}
                    itemsCount={rowsCount}
                    onPageChange={handlePageChange}
                    startIndex={startIndex}
                    endIndex={endIndex}
                  />
                </div>
              </div>
            )}

            {selectedKey === "addedituser" && (
              <div className="wf-tab-panel pt-3">
                <AddPartnerPerformer
                  selectedObj={selectedObj}
                  currentUser={currentUser}
                  handleFormSubmit={handleFormSubmit}
                  handlePermissionShowHide={handlePermissionShowHide}
                  partnerType={partnerType}
                />
              </div>
            )}

            {selectedKey === "status" && (
              <div className="wf-tab-panel pt-3">
                {selectedUserId > 0 ? (
                  <ActiveDeactiveHistory
                    selectedObj={selectedObj}
                    type="performer"
                    typeName="user"
                    actionType={actionType}
                    handlePermissionShowHide2={handlePermissionShowHide2}
                  />
                ) : (
                  <div className="wf-empty-state">
                    <div className="wf-empty-icon">
                      <i className="fa fa-toggle-on" aria-hidden="true" />
                    </div>
                    <p className="wf-empty-title">No User Selected</p>
                    <p className="wf-empty-desc">
                      Select a user from the <strong>Users</strong> tab to activate, deactivate, or review their status history.
                    </p>
                    <button
                      className="btn-action-search"
                      onClick={() => handleTabSelect("home")}
                      style={{ marginTop: 4 }}
                    >
                      <i className="fa fa-arrow-left" /> Back to Users
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        {wfForm && viewFormType && (
          <div className="p-0 border-0 mt-3 animation-fade-in" style={{ animation: 'tabFadeIn 0.4s ease both' }}>
            <div className="pop-container" style={{ border: '1px solid #e2e8f0', borderRadius: '16px', overflow: 'hidden', background: 'white', boxShadow: '0 10px 30px rgba(0,0,0,0.05)' }}>
              <div className="pop-header" style={{ padding: '16px 24px', borderBottom: '1px solid #f1f5f9', background: '#f8fafc', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h4 className="m-0" style={{ fontWeight: 500, fontSize: '14px', color: '#1e293b', fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}>
                  <i className="fa fa-file-text-o mr-2" />
                  Partner Form Details
                </h4>
                <button
                  className="pop-action-btn back"
                  onClick={() => handleViewSubcontractorForm(`${viewFormType}`, null)}
                  style={{ background: 'white', border: '1px solid #cbd5e1', padding: '7px 14px', borderRadius: '0', cursor: 'pointer', fontSize: '14px', fontWeight: 500, color: '#1e293b', fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif', boxShadow: '0 2px 5px rgba(15, 23, 42, 0.08)' }}
                >
                  <i className="fa fa-times mr-2" />Close
                </button>
              </div>
              <div className="p-4">
                <WorkflowElement
                  wfTask={wfTask}
                  wfForm={wfForm}
                  handleNextTask={handleNextTask}
                  viewType={true}
                  appSummary={false}
                  codeVerified={true}
                  wfTaskType={"form"}
                  updatedStateData={updatedStateData}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </React.Fragment>
  );
}
